import React from 'react';
import { string, arrayOf, shape, oneOf } from 'prop-types';
import classNames from 'classnames/bind';

import InfoGrayBox from 'components/InfoGrayBox';

import ParagraphTextText from '../ParagraphTextText';
import ParagraphFullText from '../ParagraphFullText';
import ParagraphMultipleImages from '../ParagraphMultipleImages';
import ParagraphImageText from '../ParagraphImageText';
import ParagraphFullImage from '../ParagraphFullImage';

import WithBlurPopin from 'containers/WithBlurPopin';
import { withLabels } from 'containers/withLabels';

import styles from './DocumentsInfo.module.scss';
const cx = classNames.bind(styles);

const DocumentsInfo = ({ data, labels }) => (
  <div className={cx('container')}>
    {data.product_designation && (
      <div className={cx('designation')}>{data.product_designation}</div>
    )}
    {data.title && <h1 className={cx('title')}>{data.title}</h1>}
    <WithBlurPopin>
      <InfoGrayBox
        data={data}
        title={labels.documentInfoTitle}
        isTechDocuments
      />
      {data.valeo_id && (
        <div className={cx('valeo-info')}>
          <span className={cx('valeo-id')}>{data.valeo_id}</span>&nbsp;–&nbsp;
          <span className={cx('date')}>{data.modified_date}</span>
        </div>
      )}

      {data.paragraphs && (
        <div className={cx('paragraphs-list')}>
          {data.paragraphs.map(({ items, type }, i) => (
            <div className={cx('paragraph')} key={i}>
              {type === 'paragraph_full_text' && (
                <ParagraphFullText data={items} />
              )}
              {type === 'paragraph_text_text' && (
                <ParagraphTextText data={items} />
              )}
              {type === 'paragraph_text_image' && (
                <ParagraphImageText data={items} />
              )}
              {type === 'paragraph_image_text' && (
                <ParagraphImageText data={items} isImageLeft={true} />
              )}
              {type === 'paragraph_image_multiple' && (
                <ParagraphMultipleImages data={items} />
              )}
              {type === 'paragraph_full_image' && (
                <ParagraphFullImage data={items} />
              )}
            </div>
          ))}
        </div>
      )}
    </WithBlurPopin>
  </div>
);

DocumentsInfo.propTypes = {
  data: shape({
    title: string,
    short_description: string,
    paragraphs: arrayOf(
      shape({
        type: oneOf([
          'paragraph_full_text',
          'paragraph_text_text',
          'paragraph_text_image',
          'paragraph_full_image',
          'paragraph_image_text',
          'paragraph_image_multiple',
        ]),
      })
    ),
  }).isRequired,
};

export default withLabels(DocumentsInfo);



// WEBPACK FOOTER //
// ./src/pages/TechnicalDocument/components/DocumentsInfo/DocumentsInfo.js